import { Fieldset, Radio, ValidationMessage } from '@digdir/designsystemet-react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Varmekilde } from '../../../../../../../components/registering/utils/registerEnums';
import { OppvarmingFormData } from '../../../types';

export const VarmekildeRadio = () => {
  const { register, formState } = useFormContext<OppvarmingFormData>();
  const { t } = useTranslation('', { keyPrefix: 'form.oppvarming.varmepumpe' });

  const error = formState.errors.varmepumpe?.value?.varmekilde?.message;

  return (
    <Fieldset>
      <Fieldset.Legend>{t('varmekilde.label')}</Fieldset.Legend>
      <Radio
        aria-invalid={!!error}
        {...register('varmepumpe.value.varmekilde', { required: t('varmekilde.error'), shouldUnregister: true })}
        label={t(`varmekilde.options.${Varmekilde.LuftFraDetFri}`)}
        value={Varmekilde.LuftFraDetFri}
      />
      <Radio
        aria-invalid={!!error}
        {...register('varmepumpe.value.varmekilde', { required: t('varmekilde.error'), shouldUnregister: true })}
        label={t(`varmekilde.options.${Varmekilde.LuftFraVentilasjonsanlegg}`)}
        value={Varmekilde.LuftFraVentilasjonsanlegg}
      />
      <Radio
        aria-invalid={!!error}
        {...register('varmepumpe.value.varmekilde', { required: t('varmekilde.error'), shouldUnregister: true })}
        label={t(`varmekilde.options.${Varmekilde.Vann}`)}
        value={Varmekilde.Vann}
      />
      <Radio
        aria-invalid={!!error}
        {...register('varmepumpe.value.varmekilde', { required: t('varmekilde.error'), shouldUnregister: true })}
        label={t(`varmekilde.options.${Varmekilde.JordGrunnFjell}`)}
        value={Varmekilde.JordGrunnFjell}
      />
      {!!error && <ValidationMessage>{error}</ValidationMessage>}
    </Fieldset>
  );
};
